import React from 'react'
import Box from '@mui/material/Box'
import NextImage from 'next/image'
import VariantImages from '@/assets/VariantImages'

const gradientStyle = {
  position: 'absolute',
  left: 0,
  width: '100vw',
  height: '100vh',
  zIndex: -1,
  background: 'linear-gradient(180deg, rgba(224, 27, 63, 0) 0%, #E01B3F 45%, #E01B3F 55%, rgba(224, 27, 63, 0) 100%)',
}

const GradientBox = ({ isBottom = false, delay = 0 }) => (
  <Box
    sx={{
      ...gradientStyle,
      [isBottom ? 'bottom' : 'top']: 0,
      [`@keyframes moveGradient${isBottom ? '2' : ''}`]: {
        '0%': {
          opacity: 0,
          transform: 'translateY(0)',
        },
        '25%': {
          opacity: 1,
          transform: 'translateY(0)',
        },
        '75%': {
          opacity: 1,
          transform: `translateY(${isBottom ? '100%' : '-100%'})`,
        },
        '100%': {
          opacity: 0,
          transform: `translateY(${isBottom ? '100%' : '-100%'})`,
        },
      },
      animation: `moveGradient${isBottom ? '2' : ''} 5s linear ${delay}s infinite`,
    }}
  />
)

const WelcomeLoader: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        backgroundImage: 'url(/theme/header-pattern.png)',
        backgroundSize: '200%',
        backgroundPosition: 'center',
        backgroundColor: 'primary.main',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 11,
        position: 'fixed',
        top: 0,
        left: 0,
        flexDirection: 'column',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -1,
        },
      }}
    >
      <Box sx={{ position: 'absolute', width: '100%', height: '50vh', top: 0, left: 0, overflow: 'hidden' }}>
        <GradientBox delay={0} />
        <GradientBox delay={2.5} />
      </Box>

      <Box sx={{ textAlign: 'center' }}>
        <NextImage
          src={VariantImages.Logo}
          alt={'Site logo'}
          quality={100}
          style={{ objectFit: 'contain', maxWidth: '100%', margin: '0 auto' }}
        />
      </Box>

      <Box sx={{ position: 'absolute', width: '100%', height: '50vh', bottom: 0, left: 0, overflow: 'hidden' }}>
        <GradientBox isBottom delay={0} />
        <GradientBox isBottom delay={2.5} />
      </Box>
    </Box>
  )
}

export default WelcomeLoader
